// Qué encuadrar cuando llega una tanda nueva al lienzo —
// ADR-2026-10-05-el-encuadre-espera-a-que-react-flow-tenga-las-celdas.
//
// El encuadre pide `fitView({ nodes })` con los ids de las celdas de la tanda. React Flow
// busca esos ids en SU store, y si no encuentra ninguno encuadra una caja vacía en el
// origen: el viewport salta a (0,0) a zoom máximo, lejos de donde se está generando. Y
// las celdas de una tanda nueva llegan al store un render DESPUÉS de que la tanda
// aparece (se le entregan con `setNodes`). Por eso la decisión es pura y en dos partes:
// qué tandas faltan encuadrar, y si ya se puede (todas sus celdas están en el store) o
// hay que esperar al próximo render sin descartar el pedido.

/** Las tandas que todavía no se encuadraron, en el orden del lienzo. */
export function tandasSinVer(
  tandas: readonly { id: string }[],
  vistas: ReadonlySet<string>,
): string[] {
  return tandas.filter((t) => !vistas.has(t.id)).map((t) => t.id);
}

/**
 * Las celdas de las tandas pedidas, listas para `fitView`; `null` si alguna todavía no
 * está en React Flow (hay que esperar, sin olvidar el pedido). Lista vacía si las tandas
 * no tienen celdas: no hay nada que encuadrar ni que esperar.
 */
export function celdasParaEncuadrar(
  nodos: readonly { id: string; data: { tandaId: string } }[],
  tandaIds: readonly string[],
  estaEnReactFlow: (id: string) => boolean,
): { id: string }[] | null {
  const pedidas = new Set(tandaIds);
  const celdas = nodos.filter((n) => pedidas.has(n.data.tandaId));
  if (celdas.some((n) => !estaEnReactFlow(n.id))) return null;
  return celdas.map((n) => ({ id: n.id }));
}
